// @flow
import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import './Privacy.css';

export default function (props: {}): React.Dom {
  return (
    <main className="privacy">
      <Header noShadow/>
      <div className="jumbo">
        <h1 className="container">Privacy Policy</h1>
      </div>
      <div className="container">
        <p>
          This policy explains what information we collect when you use Find Help's sites, services, mobile applications, products, and content (“Services”). It also has information about how we store, use, transfer, and delete that information. Our aim is not just to comply with privacy law. It’s to earn your trust.
        </p>
        <h2>1.0 Information We Collect & How We Use It</h2>
        <p>
          We don't store any of the information you give us. Find Help doesn’t make money from ads. So we don’t collect data in order to advertise to you. The tracking we do at Find Help is to make our product work as well as possible.
        </p>
        <h2>2.0 Information Disclosure</h2>
        <p>
          Find Help won’t transfer information about you to third parties for the purpose of providing or facilitating third-party advertising to you. We won’t sell information about you.
          We may share your account information with third parties in some circumstances, including: (1) with your consent; (2) to a service provider or partner who meets our data protection standards; (3) with academic or non-profit researchers, with aggregation, anonymization, or pseudonomization; (4) when we have a good faith belief it is required by law, such as pursuant to a subpoena or other legal process; (5) when we have a good faith belief that doing so will help prevent imminent harm to someone.
          If we are going to share your information in response to legal process, we’ll give you notice so you can challenge it (for example by seeking court intervention), unless we’re prohibited by law or believe doing so may endanger others. We will object to requests for information about users of our services that we believe are improper.
        </p>
        <h2>3.0 Data Storage</h2>
        <p>
          Find Help uses third-party vendors and hosting partners, such as Google, for hardware, software, networking, storage, and related technology we need to run Find Help. We maintain two types of logs: server logs and event logs. By using Find Help Services, you authorize Find Help to transfer, store, and use your information in the United States and any other country where we operate.
        </p>
        <h2>4.0 Tracking & Cookies</h2>
        <p>
          We use browser cookies and similar technologies to recognize you when you return to our Services. We use them in various ways, for example to log you in and evaluate email effectiveness.
          Find Help doesn’t track you across the Internet. We track only your interactions within the Find Help network (which encompasses FindHelp.org.uk and custom domains hosted by Find Help).
          Some third-party services that we use to provide the Find Help Service, such as Firebase Analytics, may place their own cookies in your browser. This Privacy Policy covers use of cookies by Find Help only and not the use of cookies by third parties.
          Find Help complies with the “Do Not Track” (“DNT”) standard recommended by the World Wide Web Consortium. For logged-out users browsing with DNT enabled, Find Help’s analytics will not receive data about you, but we will do some first-party tracking in order to customize content and provide data to third-party service providers that enable Find Help Services to work. When you use Find Help while logged-in to your account, we cannot comply with DNT. Here’s some more information about Find Help’s Do Not Track policy.
        </p>
        <h2>5.0 Changes to this Policy</h2>
        <p>
          Find Help may periodically update this Policy. We’ll notify you about significant changes to it. The most current version of the policy will always be at findhelp.org.uk/privacy-policy.
        </p>
        <h2>6.0 Questions</h2>
        <p>
          We welcome feedback about this policy at support@swiftlab.co.uk.
        </p>
      </div>
      <Footer/>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/Pages/Privacy.js